import React from "react";
import { Navbar } from "@/components/Navbar";
import { ChoirPractice } from "@/components/ChoirPractice";

export default function ChoirPracticePage() {
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-8 lg:py-16" data-testid="choir-practice-page">
        <p className="font-mono text-xs uppercase tracking-widest text-primary">Training</p>
        <h1 className="mt-2 font-serif text-4xl tracking-tight sm:text-5xl">Choir Part Practice</h1>
        <p className="mt-4 text-base text-muted-foreground md:text-lg">Pick your voice part and sing it with the score in front of you, while the other three parts play softly underneath. Not sure of your part? Try the Voice Range Finder in the Singers course.</p>
        <div className="mt-8"><ChoirPractice testId="choir-practice-standalone" /></div>
      </main>
    </div>
  );
}
